module.exports = "<div class=\"modal\" v-bind:class=\"classModifier\" v-show=\"isVisible\" v-on:click=\"hide\">\n  <div class=\"modal__align\">\n    <div class=\"modal__cell\">\n      <div class=\"modal__box\" v-on:click.stop>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/modals/partials/header.html
// module id = rvop
// module chunks = 1